import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Map, Marker, TileLayer, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import Pin from "../Pin";
import ReactDOMServer from "react-dom/server";
import deliveryProfile from "../../../../assets/delivery-man.png";
import styles from './style.module.css';
import { SetActiveDriverList, SetDriverListOpenDialoge, SetDriverPopUp, SetOrderPinPopUp, SetOrderPinPopUpPosition, SetSelectedMonitoringDriver, SetSelectedMonitoringOrder } from "../../../../Redux/actions/actionNames";
import { useDispatch, useSelector } from "react-redux";
import { GetDriverInfoAction, GetDriverOrderListAction } from "../../../../Redux/actions/actions";
import "./customPopup.css";
import { useTranslation } from "react-i18next";
import { useDriverMonitoringPin } from "../../../../hooks/useDriverMonitoringPin";
import { getOrderMonitoringBounding } from "../getOrderMonitoring";
import { margin } from "polished";

const createtIcon = ({position, onClick ,  text , big ,color , selected , allSelected}) => {
  return new L.divIcon({
    className: "",
    html: ReactDOMServer.renderToString(CreateIconSelectedOsm({position, onClick ,  text , big ,color , selected , allSelected  })),
    iconSize: [40, 41],
    iconAnchor: [20, 42],
  });
};


 const customIcon = L.divIcon({
  
    className: 'custom-icon', // کلاس CSS برای استایل
    html: '<div style="background-color: red; color: white; padding: 5px;">Custom Icon</div>', // محتوای HTML
    iconSize: [100, 40], // اندازه آیکون
    iconAnchor: [50, 20], // نقطه لنگر آیکون
  });



const CreateIconSelectedOsm = ({position, onClick ,  text , big ,color , selected , allSelected}) => {
  return  <Pin text={text} big={big} color={color} selected={selected} allSelected={allSelected}  style={(allSelected ||selected ) ? {cursor:"pointer" ,marginLeft:"4px",marginTop:"-8px",marginBottom:"0px"} :{cursor:"pointer" ,marginLeft:"8px",marginTop:"0px",marginBottom:"0px"}} />
 

};


const App = ({position, onClick ,  text , big ,color , selected , allSelected}) => {
 const markerRef = useRef();
   const handleMarkerClick = (e) => {
            L.DomEvent.stopPropagation(e); // Stop propagation to the map
            console.log("sczsdf ",e.originalEvent)
            if (e.originalEvent.ctrlKey) {
              alert('Ctrl + click on marker detected!');
              // Perform your desired action here
            } else {
              alert('Regular click on marker detected!');
            }
          };

  //          useEffect(() => {
  //   const marker = markerRef.current.leafletElement;

  //   // افزودن رویداد کلیک
  //   marker.on('click', (e) => {
  //     console.log("sczsdf ",e)

  //     alert('Marker clicked!');
  //   });

  //   // پاک کردن رویداد هنگامUnmount شدن کامپوننت
  //   return () => {
  //     marker.off('click');
  //   };
  // }, []);


  return <>

 
    <Marker
      animate={true}
      position={position}
      // ref={markerRef}
      onClick={onClick}
       icon={createtIcon({position, onClick ,  text , big ,color , selected , allSelected})}
    >
 
    </Marker>

    {/* {DriverPopUp == driver.id  && <div position={position} id={`${driver.id}popup`} className={"monitoringDriverSelected markerIcon "+styles.OsmMarkerPopUp} style={{ left: `-${(width / 2) - 25}px`}}>
      <span className={styles.OsmMarkerPopUpName}> {driver.name} </span>
      <span className={styles.OsmMarkerPopUpButton} onClick={OpenUserProfile} > Profileee </span>
    </div>} */}
  </>
};

export default App


